import React from 'react';
import { motion } from 'framer-motion';

export const GlassCard = ({ children, className = '', delay = 0 }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      className={`bg-black/40 backdrop-blur-xl border border-white/10 rounded-xl p-6 shadow-2xl ${className}`}
    >
      {children}
    </motion.div>
  );
};